module.exports = __webpack_public_path__ + "img/thumb-griffin2a.7fd3872f.png";